import type { DriveLiveReadReason } from '@vivport/backend/types';

export interface DriveFileRowData {
  name: string;
  path: string;
  sizeBytes: number | null;
  mimeType: string | null;
  modifiedAt: string | null;
  webUrl: string | null;
  mirroredContentId: number | null;
  mirroredCode: string | null;
}

const BYTE_UNITS = ['B', 'KB', 'MB', 'GB'] as const;

export function formatBytes(bytes: number): string {
  let value = Math.max(bytes, 0);
  let unit = 0;
  while (value >= 1024 && unit < BYTE_UNITS.length - 1) {
    value /= 1024;
    unit += 1;
  }
  return unit === 0 ? `${Math.round(value)} ${BYTE_UNITS[unit]}` : `${value.toFixed(1)} ${BYTE_UNITS[unit]}`;
}

export function folderPart(path: string): string {
  const index = path.lastIndexOf('/');
  return index <= 0 ? '/' : path.slice(0, index);
}

export function formatDriveDate(iso: string | null): string | null {
  if (iso === null) return null;
  const date = new Date(iso);
  return Number.isNaN(date.getTime()) ? null : date.toLocaleDateString();
}

export const DRIVE_READ_REASON_LABELS: Record<Exclude<DriveLiveReadReason, 'OK'>, string> = {
  NOT_FOUND: 'Not found on the drive',
  IS_FOLDER: 'This path is a folder',
  UNSUPPORTED_TYPE: 'Unsupported file type',
  TOO_LARGE: 'Too large to read',
  NO_TEXT_FOUND: 'No text found',
};
